import React from "react";
import { useNavigate } from "react-router-dom";
import { Car, LogOut, User as UserIcon, ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/auth";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export const TopBar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isLeader = user?.role === "team_leader";

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4 lg:h-16">
        <div className="flex items-center gap-2.5 lg:hidden">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-navy text-primary-foreground">
            <Car className="h-4 w-4" />
          </div>
          <span className="font-display text-base font-extrabold tracking-tight">RVSF CRM</span>
        </div>
        <div className="hidden lg:block" />

        <DropdownMenu>
          <DropdownMenuTrigger className="flex items-center gap-2 rounded-full py-1 pl-1 pr-2 outline-none transition-colors hover:bg-secondary focus-visible:ring-2 focus-visible:ring-ring">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
              {(user?.full_name || "?").slice(0, 1)}
            </div>
            <span className="hidden max-w-[120px] truncate text-sm font-medium sm:block">
              {user?.full_name}
            </span>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              <div className="font-semibold">{user?.full_name}</div>
              <div className="flex items-center gap-1 text-xs font-normal text-muted-foreground">
                {isLeader ? <ShieldCheck className="h-3 w-3" /> : <UserIcon className="h-3 w-3" />}
                {isLeader ? "Team Leader" : "Employee"}
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => navigate("/more")}>
              <UserIcon className="mr-2 h-4 w-4" /> Profile & Activity
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={logout} className="text-destructive focus:text-destructive">
              <LogOut className="mr-2 h-4 w-4" /> Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};
